export default __webpack_public_path__ + "static/media/logo-transparente.81a83eb7.png";